import RequestManager from "../../requests/RequestManager";
import ReminderListTask from "../../requests/tasks/user/ReminderListTask";
import storage from '../../components/DeviceStorage/DeviceStorage';
import Metadata from '../../requests/apa/Metadata';
import {Dates} from '../../packages/dates';
import Utils from "../Utils";
import EpgPersistence from "../../AAF/Nepg/EpgPersistence";
import store from "../../store";
import { showEventReminderNotification } from "../../actions/notification";
import { deleteReminder } from "../../requests/loader";

class ReminderNotifications {
    constructor() {
        this.ReminderService = new ReminderListTask();
        this.jsonReminders = [];
        this.notificationFunction = ()=>{};
        this.lasttouchFunction = ()=>{};
        this.playFullMediaFunction = ()=>{};
        this.closeNotificationFunction = ()=>{};
        this.getReminders = this.getReminders.bind(this);
        this.setReminders = this.setReminders.bind(this);
        this.requestHandler = this.requestHandler.bind(this);
        this.setIntervalRemindersSync = this.setIntervalRemindersSync.bind(this);
        this.reminders = {};
        this.remindersBefore = [];
    }

    initReminders(reminders = []){
        const minutesBeforeToReminder = 10; // improve from metadata;
        this.reminders = {};
        const todayTimestamp = Utils.nowAsTimestampSeconds();
        reminders.forEach(reminder => {
            const { data : { begintime = "YYYY-MM-DD HH:mm:ss", id: eventId } = {}, id: reminderId } = reminder;
            const beginTimeDates =
                EpgPersistence.needsOffset() ?
                new Dates(`${begintime}`, "YYYY-MM-DD HH:mm:ss").utcOffset(EpgPersistence.needsOffset(), true):
                new Dates(`${begintime}`, "YYYY-MM-DD HH:mm:ss");
            beginTimeDates.subtract(minutesBeforeToReminder, 'minutes');
            if( beginTimeDates.unix() >= todayTimestamp){
                this.reminders[eventId] = reminderId;
            }
        });
    }

    setReminderByEventId(eventId, reminderId){
        if(eventId){
            this.reminders[event_id] = reminderId;
        }
    }

    clearReminderByEventId(eventId){
        if(eventId){
            delete this.reminders[eventId];
        }
    }

    hasEventReminder(eventId){
        return !!this.reminders[eventId]
    }

    async requestHandler() {
        let result;
        try {
        result = await RequestManager.addRequest(this.ReminderService);
            return new Promise((resolve, reject) => {
              if(result.response && Array.isArray(result.response)){
                let found=result.response.find(it=> typeof it.data === 'string');
                if(found){
                  result.response=Utils.parseData(result.response);

                }
                this.remindersBefore = result.response;
                resolve(result.response);
              }
              else{
                resolve([]);
              }
            });
        } catch(err) {
            return this.remindersBefore;
        }
    }

    async getReminders(minutes = 0, reminderResponse = null) {
        const remindersFromService = Array.isArray(reminderResponse) ? reminderResponse : await this.requestHandler();
        if(!Array.isArray(remindersFromService)){
            return [];
        }
        const minutesBeforeToReminder = 10; // improve from metadata;
        //update reminders local structure
        this.initReminders(remindersFromService);
        return remindersFromService.reduce( (res, reminder) => {
            const {
                id: reminder_id,
                channel_id,
                data : {
                    id: event_id,
                    channel_name,
                    name: event_name,
                    channel_number,
                    channel_image,
                    begintime,
                    endtime,
                    channel_group_id: group_id
                } = {}
            } = reminder;
            const timeoutIdFound = this.jsonReminders.find( reminder => reminder.reminder_id === reminder_id);
            let timeoutId = timeoutIdFound && timeoutIdFound.timeoutId? timeoutIdFound.timeoutId : null;
            const todayDates = Utils.now(true);
            const todayTimestamp = Utils.nowAsTimestampSeconds();
            const limitTimestamp = todayDates.add(minutes, 'minutes').unix();
            const beginTimeDates =
                EpgPersistence.needsOffset() ?
                new Dates(`${begintime}`, "YYYY-MM-DD HH:mm:ss").utcOffset(EpgPersistence.needsOffset(), true):
                new Dates(`${begintime}`, "YYYY-MM-DD HH:mm:ss");
            const endTimeDates = 
                EpgPersistence.needsOffset() ?
                new Dates(`${endtime}`, "YYYY-MM-DD HH:mm:ss").utcOffset(EpgPersistence.needsOffset(), true):
                new Dates(`${endtime}`, "YYYY-MM-DD HH:mm:ss");
            const notificationTimeDates = new Dates(beginTimeDates);
            notificationTimeDates.subtract(minutesBeforeToReminder, 'minutes');
            const notificationTimestamp = notificationTimeDates.unix();
            if ( notificationTimestamp >= todayTimestamp && notificationTimestamp < limitTimestamp ) {
                const schedule = `${beginTimeDates.format('HH:mm')}hs a ${endTimeDates.format('HH:mm')}hs`;
                const timeToSet = ((notificationTimestamp - todayTimestamp) * 1000);
                if(!timeoutId){
                    const event = {
                        id: event_id,
                        reminder_id,
                        name: event_name,
                        channelNumber: channel_number, 
                        channelImage: channel_image, 
                        schedule: schedule,
                        group_id
                    };
                    timeoutId= this.getNotificationTimeout(event, timeToSet);
                }
                res.push({
                    reminder_id,
                    event_name,
                    channel_name,
                    channel_id,
                    notificationTimestamp,
                    notificationTimeFormatted: notificationTimeDates.format('HH:mm:ss'),
                    channel_number,
                    timeoutId,
                    channel_image,
                    schedule: `${beginTimeDates.format('HH:mm')}hs a ${endTimeDates.format('HH:mm')}hs`,
                    group_id
                })
            }
            return res
        }, []);
    }

    getNotificationTimeout(event, timeToSet, ){
        return setTimeout(() => {
            this.clearReminderByEventId(event.id);
            this.removeReminderFromList(event.reminder_id)
            deleteReminder(event.reminder_id).then( response => {
                if(response && response.lasttouch && response.lasttouch.reminder){
                    this.lasttouchFunction(response.lasttouch.reminder);
                }
            });
            const groupId = event.group_id;
            delete event.id;
            delete event.reminder_id;
            delete event.group_id;
            this.notificationFunction( 
                event, ()=> {
                    this.handleRedPress(groupId);
                },
                this.handleGreenPres
            );
        }, timeToSet);
    }

    handleRedPress  = groupId => {
        if(groupId){
            const params = {
                playerstate: 'PLAYING',
                source: {
                    videoid: groupId
                },
                size: {
                    top: 0,
                    left: 0,
                    width: 1280,
                    height: 720
                },
                ispreview: false,
                islive: true,
                ispip: false,
                event: null
            };
            this.playFullMediaFunction(params);
        }
    }

    handleGreenPres = () => {
        this.closeNotificationFunction({
            show: false,
        });
    }

    async setReminders(minutes = 0, init = true, reminderResponse = null) {
        this.jsonReminders = await this.getReminders(minutes, reminderResponse);
    }

    clearTimeoutReminder = (reminderId) =>{
        this.jsonReminders = this.jsonReminders.map(json=>{
            if(json.reminder_id === reminderId){
                clearTimeout(json.timeoutId);
                json.timeoutId=null;
            }
            return json;
        });
    }

    removeReminderFromList(reminderId){
        this.jsonReminders = this.jsonReminders.filter( reminder => reminder.reminder_id !== reminderId );
    }

    setIntervalRemindersSync(minutes, cbNotification, cbLasttouch, cbPlayFullMedia, cbCloseNotificacion) {
        const intervalTime = minutes * 60000;
        this.notificationFunction = cbNotification;
        this.lasttouchFunction = cbLasttouch;
        this.playFullMediaFunction = cbPlayFullMedia;
        this.closeNotificationFunction = cbCloseNotificacion;
        this.setReminders(minutes);
        if (this.sentileInterval){
            clearInterval(this.sentileInterval);  
        }
        this.sentileInterval = setInterval(() => {
            this.setReminders(minutes);
        }, intervalTime);
    }
}

export default new ReminderNotifications();



// WEBPACK FOOTER //
// ./src/utils/RemindersNotifications/ReminderNotifications.js